import type { TransactionType } from "@validereinc/domain";

export const selectFirstAndLastTransactionState = (
  transactionWithHistory?: TransactionType[]
) => {
  return {
    firstTransaction: transactionWithHistory?.at(0),
    lastTransaction: transactionWithHistory?.at(-1),
  };
};
